import axios from 'axios';
import {
  ResolvedVideoShare,
  VideoDownloadUrl,
  VideoDownloadUrlResponse,
  VideoShareResponse
} from '@companion-professional/dctypes';

// resolveVideoShare fetches the share behind a short code: when it was created and its videos. The endpoint is public — the short code is the only
// credential — so this is a plain unauthenticated request. Each returned item's item_info.signed_playback_url is a
// pre-signed, time-limited URL ready to hand to the video player. A 404 means the code is unknown or has expired.
export const resolveVideoShare = async (shortCode: string): Promise<ResolvedVideoShare> => {
  const response = await axios.get<VideoShareResponse>(`/api/v3/video_share/${encodeURIComponent(shortCode)}`);
  return response.data.data;
};

// getSharedVideoDownloadUrl fetches a short-lived, pre-signed URL from which the original upload of one video in a share
// can be downloaded. Like resolveVideoShare it is unauthenticated. The backend returns a 409 if the video is not yet
// available (a rare upload race), and a 404 if the share has expired or does not include the item.
export const getSharedVideoDownloadUrl = async (shortCode: string, itemId: string): Promise<VideoDownloadUrl> => {
  const response = await axios.get<VideoDownloadUrlResponse>(
    `/api/v3/video_share/${encodeURIComponent(shortCode)}/download_url/${encodeURIComponent(itemId)}`
  );
  return response.data.data;
};
